/*
 * A download button's state (S47): downloadAttachment, run as an action so a
 * failure is held for the page to show beside the button rather than lost in a
 * click handler. One per place that downloads - the reader's article, the
 * editor, the library - so an error appears where the click was.
 */

import { useCallback } from 'react';
import type { AttachmentDownloadLink } from '@accotool-kb/shared';
import { downloadAttachment } from '../api/attachmentDownload.js';
import { useAction } from './useAsync.js';

export interface AttachmentDownloadState {
  download: (fetchLink: () => Promise<AttachmentDownloadLink>) => Promise<void>;
  running: boolean;
  error: Error | null;
  clearError: () => void;
}

export function useAttachmentDownload(): AttachmentDownloadState {
  const action = useAction();
  const { run } = action;
  const download = useCallback(
    async (fetchLink: () => Promise<AttachmentDownloadLink>) => {
      await run(() => downloadAttachment(fetchLink));
    },
    [run],
  );
  return { download, running: action.running, error: action.error, clearError: action.clearError };
}
